import React, { useState, useEffect } from 'react'
import {
  Row, Col,
  FormGroup, FormText,
  Label, Input, Button, CustomInput
} from 'reactstrap'
import _, { find, reduce, map, cloneDeep, isEmpty, uniqBy } from 'lodash'
import ReactSelect from 'react-select'
import {
  Card, CardHeader,
  CardBody
} from 'reactstrap'

import CurrencyInput from 'components/Input/currencyInput'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import Lang from 'Lang/General'
import PortalMatchmakingHoc from './actions'
import { DEFAULT_PORTAL_USER_MATCHMAKING } from './assets'
import './index.scss'

const MapPortalUserMatchmaking = (portalUserMatchmaking, countries, states) => {
  let tmpMatchmaking = cloneDeep(portalUserMatchmaking)

  tmpMatchmaking.country_selected = portalUserMatchmaking.country
    ? find(countries, { id: portalUserMatchmaking.country })
    : null
  tmpMatchmaking.expansion_countries_selected = portalUserMatchmaking.expansion_countries
    ? countries.filter(country => portalUserMatchmaking.expansion_countries.findIndex(expansionCountrySelected => expansionCountrySelected === country.id) > -1)
    : []
  tmpMatchmaking.expansion_states_selected = portalUserMatchmaking.expansion_states.length > 0
    ? states.filter(state => portalUserMatchmaking.expansion_states.findIndex(stateSelected => stateSelected === state.id) > -1)
    : []

  return tmpMatchmaking
}

const SetCurrentMatchmaking = (props, key, value) => {
  let tmpMatchmakings = cloneDeep(props.currentMatchmakings)
  tmpMatchmakings[ props.selectedMatchmakingCountry ][props.selectedMatchmakingIndex][key] = value
  props.onChangePortalMatchmakingHOC('currentMatchmakings', tmpMatchmakings)
}

const PortalMatchmaking = props => {
  const [ fairCountryOptions, setFairCountryOptions ] = useState( [] )
  const [ matchmakingCountryName, setMatchmakingCountryName ] = useState( '' )

  useEffect(() => {
    if (props.selectedPortalUsers?.id) {
      props.getPortalUserMatchmakings(props.selectedPortalUsers?.id)
      props.getBrandsListing(props.selectedPortalUsers?.id)
      props.getCountries()
      props.onChangePortalMatchmakingHOC( 'selectedMatchmakingCountry', props.selectedPortalUsers.fairs[ 0 ]?.country || ''  )
      props.onChangePortalMatchmakingHOC( 'fairCountries', uniqBy( props.selectedPortalUsers.fairs, 'country' ).map( fairBooking => fairBooking.country ) )
    }
  }, [props.selectedPortalUsers.id])

  useEffect(() => {
    if (
      props.isPortalUserMatchmakingsLoaded &&
      props.isCountriesLoaded &&
      props.isStatesLoaded &&
      props.isPortalUserBrandsLoaded &&
      props.fairCountries.length > 0
    ) {
      let tmpCountryMatchmakings = {}
      let tmpCountryMatchmakingErrors = {}

      props.fairCountries.map( fairCountry => {
        let tmpCompanyMatchmaking = (
          find( props.portalUserMatchmakings, matchmaking => !matchmaking.brand_id && matchmaking.fair_country === fairCountry ) || 
          { ...DEFAULT_PORTAL_USER_MATCHMAKING, fair_country: fairCountry }
        )
        let tmpExistingMatchmakingBrands = reduce( 
          props.portalUserMatchmakings, 
          ( res, matchmaking ) => {
            if ( matchmaking.brand_id > 0 && matchmaking.fair_country === fairCountry ) {
              return [
                ...res,
                { 
                  ...matchmaking,
                  name: find( props.portalUserBrands, { id: matchmaking.brand_id } )?.name || ''
                }
              ]
            } else {
              return res
            }
          },
          [] 
        )
        let tmpNewMatchmakingBrands = reduce( 
          props.portalUserBrands, 
          ( res, brand ) => {
            if ( !find( props.portalUserMatchmakings, { brand_id: brand.id, fair_country: fairCountry } ) ) {
              return [
                ...res,
                { 
                  ...DEFAULT_PORTAL_USER_MATCHMAKING,
                  name: brand.name,
                  brand_id: brand.id,
                  fair_country: fairCountry
                }
              ]
            } else {
              return res
            }
          },
          [] 
        )
  
        let tmpMatchmakings = [
          {
            ...tmpCompanyMatchmaking,
            name: props.selectedPortalUsers.company_name
          }
        ]

        if( props.selectedPortalUsers.is_multiple_brands ) {
          tmpMatchmakings = [
            ...tmpMatchmakings,
            ...tmpExistingMatchmakingBrands,
            ...tmpNewMatchmakingBrands  
          ]
        }

        tmpCountryMatchmakings = { 
          ...tmpCountryMatchmakings,
          [ fairCountry ]: tmpMatchmakings.map( matchmaking => MapPortalUserMatchmaking( matchmaking, props.countries, props.states ) )  
        }
        tmpCountryMatchmakingErrors = { 
          ...tmpCountryMatchmakingErrors,
          [ fairCountry ]: tmpMatchmakings.map( () => ({}) ) 
        }
      })

      setFairCountryOptions( 
        props.countries.filter( country => {
          country.id === props.selectedMatchmakingCountry && setMatchmakingCountryName( country.label )
          return props.fairCountries.includes( country.id ) 
        }) 
      )
      props.onChangePortalMatchmakingHOC( 'currentMatchmakings', tmpCountryMatchmakings )
      props.onChangePortalMatchmakingHOC( 'currentMatchmakings', tmpCountryMatchmakings )
      props.onChangePortalMatchmakingHOC( 'portalUserMatchmakingErrors', tmpCountryMatchmakingErrors )
    }
  }, [
    props.isPortalUserMatchmakingsLoaded,
    props.isCountriesLoaded,
    props.isStatesLoaded,
    props.isPortalUserBrandsLoaded,
    props.fairCountries
  ])

  return (
    <>
      {
        !isEmpty( props.currentMatchmakings ) && (
          <>
            <div className='d-flex flex-row flex-nowrap justify-content-end mt-4'>
              { 
                fairCountryOptions.length > 1 && (
                  <Input
                    type='select'
                    style={{ width: 'fit-content' }}
                    value={ props.selectedMatchmakingCountry }
                    onChange={ e => {
                      setMatchmakingCountryName( e.target.options[ e.target.selectedIndex ].text )
                      props.onChangePortalMatchmakingHOC( 'selectedMatchmakingCountry', e.target.value ) 
                    }} >
                    { fairCountryOptions.map( fairCountry => <option key={ fairCountry.label } value={ fairCountry.id } >{ fairCountry.label }</option> ) }
                  </Input>
                ) 
              }
              { 
                props.currentMatchmakings[ props.selectedMatchmakingCountry ].length > 1 && (
                  <Input
                    type='select'
                    className='ml-2'
                    style={{ width: 'fit-content' }}
                    value={ props.selectedMatchmakingIndex }
                    onChange={ e => props.onChangePortalMatchmakingHOC( 'selectedMatchmakingIndex', e.target.value ) } >
                    { props.currentMatchmakings[ props.selectedMatchmakingCountry ].map( ( matchmaking, index ) => <option value={ index } >{ matchmaking.name }</option> ) }
                  </Input>
                ) 
              }
            </div>
            <Row>
              <Col className='mb-2 mt-3' md={12} >
                <Label>{Lang['THE_MATCHMAKING_FUNCTION_ALLOWS'][props.data.languageReducer.userSettings.admin_panel_language]}</Label>
              </Col>
              <Col className='mb-2' md={6} >
                <Card>
                  <CardHeader>
                    {Lang['NATIONAL'][props.data.languageReducer.userSettings.admin_panel_language]}
                  </CardHeader>
                  <CardBody>
                    <FormGroup>
                      <Label>{Lang['PLEASE_SELECT_THE_REGIONS_FOR_YOUR_DOMESTIC_REGION'][props.data.languageReducer.userSettings.admin_panel_language]}</Label>
                      <ReactSelect
                        options={props.countries}
                        value={props.currentMatchmakings[ props.selectedMatchmakingCountry ][ props.selectedMatchmakingIndex ].country_selected}
                        onChange={e => SetCurrentMatchmaking(props, 'country_selected', e)}
                        styles={{
                          menu: provided => ({ ...provided, zIndex: 999 }),
                          menuPortal: provided => ({ ...provided, zIndex: 999 })
                        }}
                      />
                      <FormText color="danger">{props.portalUserMatchmakingErrors[ props.selectedMatchmakingCountry ][ props.selectedMatchmakingIndex ].country || ''}</FormText>
                    </FormGroup>
                    <FormGroup>
                      {
                        map(
                          {
                            NOT_IN_GERMANY: 'WE_DO_NOT_PLAN_TO_EXPAND_IN_GERMANY',
                            ALL_OF_GERMANY: 'ALL_OF_GERMANY',
                            STATES_IN_GERMANY: 'PLEASE_SELECT_THE_STATES_IN_WHICH_YOU_PLAN_TO_EXPAND'
                          },
                          (value, key) => (
                            key !== 'STATES_IN_GERMANY' ||
                            key === 'STATES_IN_GERMANY' && props.selectedMatchmakingCountry !== 'AUT' 
                          ) ? (
                            <>
                              <CustomInput
                                type='radio'
                                id={key}
                                label={ Lang[ value ][ props.data.languageReducer.userSettings.admin_panel_language ].replace( '${country}', matchmakingCountryName ) }
                                checked={props.currentMatchmakings[ props.selectedMatchmakingCountry ][ props.selectedMatchmakingIndex ].domestic_expansion_strategy === key}
                                onChange={() => SetCurrentMatchmaking(props, 'domestic_expansion_strategy', key)} >
                                {
                                  key === 'STATES_IN_GERMANY' && (
                                    <>
                                      <ReactSelect
                                        isMulti
                                        className={'mt-2'}
                                        options={props.states}
                                        isDisabled={props.currentMatchmakings[ props.selectedMatchmakingCountry ][ props.selectedMatchmakingIndex ].domestic_expansion_strategy !== 'STATES_IN_GERMANY'}
                                        value={props.currentMatchmakings[ props.selectedMatchmakingCountry ][ props.selectedMatchmakingIndex ].domestic_expansion_strategy === 'STATES_IN_GERMANY'
                                          ? props.currentMatchmakings[ props.selectedMatchmakingCountry ][ props.selectedMatchmakingIndex ].expansion_states_selected
                                          : []
                                        }
                                        onChange={e => SetCurrentMatchmaking(props, 'expansion_states_selected', e)}
                                        styles={{
                                          menu: provided => ({ ...provided, zIndex: 999 }),
                                          menuPortal: provided => ({ ...provided, zIndex: 999 })
                                        }}
                                      />
                                      <FormText color="danger">{props.portalUserMatchmakingErrors[ props.selectedMatchmakingCountry ][ props.selectedMatchmakingIndex ].expansion_states || ''}</FormText>
                                    </>
                                  )
                                }
                              </CustomInput>
                            </>
                          ) : (
                            <></>
                          )
                        )
                      }
                      <FormText color="danger">{props.portalUserMatchmakingErrors[ props.selectedMatchmakingCountry ][ props.selectedMatchmakingIndex ].domestic_expansion_strategy || ''}</FormText>
                    </FormGroup>
                  </CardBody>
                </Card>
              </Col>
              <Col className='mb-2' md={6} >
                <Card>
                  <CardHeader>
                    {Lang['INTERNATIONAL'][props.data.languageReducer.userSettings.admin_panel_language]}
                  </CardHeader>
                  <CardBody className="custom-international-radio">
                    <FormGroup>
                      {
                        map(
                          {
                            SOME_COUNTRIES: 'WE_LOOK_FOR_PARTNERS_IN_THESE_REGIONS_COUNTRIES',
                            NOT_INTERNATIONAL: 'WE_DO_NOT_PLAN_TO_EXPAND_INTERNATIONALLY',
                            ALL_COUNTRIES: 'ALL_AREAS'
                          },
                          (value, key) => (
                            <CustomInput
                              type='radio'
                              id={key}
                              label={Lang[value][props.data.languageReducer.userSettings.admin_panel_language]}
                              checked={props.currentMatchmakings[ props.selectedMatchmakingCountry ][ props.selectedMatchmakingIndex ].international_expansion_strategy === key}
                              onChange={() => SetCurrentMatchmaking(props, 'international_expansion_strategy', key)}
                            >
                              {
                                key === 'SOME_COUNTRIES' && (
                                  <>
                                    <ReactSelect
                                      isMulti
                                      className={'mt-2'}
                                      options={props.countries}
                                      isDisabled={props.currentMatchmakings[ props.selectedMatchmakingCountry ][ props.selectedMatchmakingIndex ].international_expansion_strategy !== 'SOME_COUNTRIES'}
                                      value={
                                        props.currentMatchmakings[ props.selectedMatchmakingCountry ][ props.selectedMatchmakingIndex ].international_expansion_strategy === 'SOME_COUNTRIES'
                                          ? props.currentMatchmakings[ props.selectedMatchmakingCountry ][ props.selectedMatchmakingIndex ].expansion_countries_selected
                                          : []
                                      }
                                      onChange={e => SetCurrentMatchmaking(props, 'expansion_countries_selected', e)}
                                      styles={{
                                        menu: provided => ({ ...provided, zIndex: 999 }),
                                        menuPortal: provided => ({ ...provided, zIndex: 999 })
                                      }}
                                    />
                                    <FormText color="danger">{props.portalUserMatchmakingErrors[ props.selectedMatchmakingCountry ][ props.selectedMatchmakingIndex ].expansion_countries || ''}</FormText>
                                  </>
                                )
                              }
                            </CustomInput>
                          )
                        )
                      }
                      <FormText color="danger">{props.portalUserMatchmakingErrors[ props.selectedMatchmakingCountry ][ props.selectedMatchmakingIndex ].international_expansion_strategy || ''}</FormText>
                    </FormGroup>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Card className="mt-4">
              <CardHeader>
                {Lang['FRANCHISE_INFORMATION'][props.data.languageReducer.userSettings.admin_panel_language]}
              </CardHeader>
              <CardBody>
                <Row>
                  <Col className='mb-2' md={6} >
                    <FormGroup>
                      <Label>{Lang['WE_WOULD_LIKE_TO_OPEN_OUR_NEXT_FRANCHISE_WITHIN_THE_NEXT'][props.data.languageReducer.userSettings.admin_panel_language]}</Label>
                      <Input
                        type='select'
                        value={props.currentMatchmakings[ props.selectedMatchmakingCountry ][ props.selectedMatchmakingIndex ].next_franchise_in}
                        onChange={e => SetCurrentMatchmaking(props, 'next_franchise_in', e.target.value)}
                      >
                        <option value={''} />
                        <option value='ZERO_TO_SIX_MONTHS' >{Lang['ZERO_TO_SIX_MONTHS'][props.data.languageReducer.userSettings.admin_panel_language]}</option>
                        <option value='SIX_TO_TWELVE_MONTHS' >{Lang['SIX_TO_TWELVE_MONTHS'][props.data.languageReducer.userSettings.admin_panel_language]}</option>
                        <option value='TWELVE_TO_EIGHTEEN_MONTHS' >{Lang['TWELVE_TO_EIGHTEEN_MONTHS'][props.data.languageReducer.userSettings.admin_panel_language]}</option>
                        <option value='MORE_THAN_EIGHTEEN_MONTHS' >{Lang['MORE_THAN_EIGHTEEN_MONTHS'][props.data.languageReducer.userSettings.admin_panel_language]}</option>
                      </Input>
                    </FormGroup>
                    <FormGroup>
                      <Label>{Lang['INVESTMENT_AMOUNT_HOW_MUCH'][props.data.languageReducer.userSettings.admin_panel_language]}</Label>
                      <Input
                        type='select'
                        value={props.currentMatchmakings[ props.selectedMatchmakingCountry ][ props.selectedMatchmakingIndex ].franchisor_start_amount}
                        onChange={e => SetCurrentMatchmaking(props, 'franchisor_start_amount', e.target.value)}
                      >
                        <option value={''} />
                        <option value='BETWEEN_10000_TO_24999' >{Lang['BETWEEN_10000_TO_24999'][props.data.languageReducer.userSettings.admin_panel_language]}</option>
                        <option value='BETWEEN_25000_TO_49999' >{Lang['BETWEEN_25000_TO_49999'][props.data.languageReducer.userSettings.admin_panel_language]}</option>
                        <option value='BETWEEN_50000_TO_99999' >{Lang['BETWEEN_50000_TO_99999'][props.data.languageReducer.userSettings.admin_panel_language]}</option>
                        <option value='BETWEEN_100000_TO_499999' >{Lang['BETWEEN_100000_TO_499999'][props.data.languageReducer.userSettings.admin_panel_language]}</option>
                        <option value='BETWEEN_500000_TO_999999' >{Lang['BETWEEN_500000_TO_999999'][props.data.languageReducer.userSettings.admin_panel_language]}</option>
                        <option value='OVER_1000000' >{Lang['OVER_1000000'][props.data.languageReducer.userSettings.admin_panel_language]}</option>
                        <option value='INDIVIDUAL' >{Lang['INDIVIDUAL'][props.data.languageReducer.userSettings.admin_panel_language]}</option>
                      </Input>
                    </FormGroup>
                    <FormGroup>
                      <Label>{Lang['HOW_HIGH_IS_THE_INVESTMENT_AMOUNT'][props.data.languageReducer.userSettings.admin_panel_language]}</Label>
                      <Input
                        type='select'
                        value={props.currentMatchmakings[ props.selectedMatchmakingCountry ][ props.selectedMatchmakingIndex ].investment_amount}
                        onChange={e => SetCurrentMatchmaking(props, 'investment_amount', e.target.value)}
                      >
                        <option value={''} />
                        <option value='BETWEEN_10000_TO_24999' >{Lang['BETWEEN_10000_TO_24999'][props.data.languageReducer.userSettings.admin_panel_language]}</option>
                        <option value='BETWEEN_25000_TO_49999' >{Lang['BETWEEN_25000_TO_49999'][props.data.languageReducer.userSettings.admin_panel_language]}</option>
                        <option value='BETWEEN_50000_TO_99999' >{Lang['BETWEEN_50000_TO_99999'][props.data.languageReducer.userSettings.admin_panel_language]}</option>
                        <option value='BETWEEN_100000_TO_499999' >{Lang['BETWEEN_100000_TO_499999'][props.data.languageReducer.userSettings.admin_panel_language]}</option>
                        <option value='BETWEEN_500000_TO_999999' >{Lang['BETWEEN_500000_TO_999999'][props.data.languageReducer.userSettings.admin_panel_language]}</option>
                        <option value='OVER_1000000' >{Lang['OVER_1000000'][props.data.languageReducer.userSettings.admin_panel_language]}</option>
                        <option value='INDIVIDUAL' >{Lang['INDIVIDUAL'][props.data.languageReducer.userSettings.admin_panel_language]}</option>
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col className='mb-2' md={6} >
                    <FormGroup>
                      <Label>{Lang['ENTRY_FEE'][props.data.languageReducer.userSettings.admin_panel_language]}</Label>
                      <CurrencyInput
                        width='100%'
                        currency={{ name: 'EUR', decimal_separator: ',' }}
                        value={props.currentMatchmakings[ props.selectedMatchmakingCountry ][ props.selectedMatchmakingIndex ].entry_fee}
                        onChangeValue={e => {
                          let tmp = _.cloneDeep(e)
                          if (e) {
                            tmp = tmp.replace(/[\.,]$/g, ',0')
                          }
                          SetCurrentMatchmaking(props, 'entry_fee', e ? tmp.replace(',', '.') : '')
                        }}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>{Lang['LICENSE_FEE'][props.data.languageReducer.userSettings.admin_panel_language]}</Label>
                      <Input
                        width='100%'
                        value={props.currentMatchmakings[ props.selectedMatchmakingCountry ][ props.selectedMatchmakingIndex ].license_fee}
                        onChange={ e => SetCurrentMatchmaking( props, 'license_fee', e.target.value ) }
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <div style={{ width: '100%' }}>
              <hr
                style={{
                  borderTopWidth: "1px",
                  borderTopStyle: "solid",
                  borderTopColor: 'var(--site-primary-color)'
                }} />
            </div>
            <Row>
              <Col className='mb-2 d-flex flex-column align-items-end' md={12} >
                <Button
                  onClick={() => {
                    if (props.selectedPortalUsers?.id > 0) {
                      let tmpMatchmaking = cloneDeep(props.currentMatchmakings[ props.selectedMatchmakingCountry ][ props.selectedMatchmakingIndex ])
                      tmpMatchmaking.user_id = props.selectedPortalUsers?.id || 0
                      tmpMatchmaking.country = tmpMatchmaking.country_selected?.value || ''
                      tmpMatchmaking.expansion_states = tmpMatchmaking.expansion_states_selected?.map(item => item.id) || []
                      tmpMatchmaking.expansion_countries = tmpMatchmaking.expansion_countries_selected?.map(item => item.id) || []
                      tmpMatchmaking.entry_fee = tmpMatchmaking.entry_fee ? parseFloat(tmpMatchmaking.entry_fee).toFixed(2) : ''
                      tmpMatchmaking.id > 0
                        ? props.updatePortalUserMatchmaking(tmpMatchmaking)
                        : props.createPortalUserMatchmaking(tmpMatchmaking)
                    }
                  }}
                >
                  {Lang['SAVE'][props.data.languageReducer.userSettings.admin_panel_language]}
                </Button>
              </Col>
            </Row>
          </>
        )
      }
      {props.onLoadPortalMatchmakingHoc && <LoadingOverlay siteSettings={props.siteSettings} />}
    </>
  )
}

export default PortalMatchmakingHoc(PortalMatchmaking)